/* eslint-disable no-bitwise */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.module.scss';

const propTypes = {
  value: PropTypes.number,
  round: PropTypes.bool,
  animate: PropTypes.bool,
  currency: PropTypes.string,
  className: PropTypes.string
};

const Money = ({value = 0, round = false, animate = false, currency = 'USD', className = ''}) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0
  });

  if (round) {
    value = Math.round(value);
  }

  const fullOutput = formatter.format(value);
  const symbol = fullOutput.substring(0, 1);
  const output = fullOutput.slice(1);

  return (
    <span
      className={cx(className, {
        [styles.money]: true,
        [styles.animate]: animate
      })}>
      <i>{symbol}</i>
      {output}
    </span>
  );
};

Money.propTypes = propTypes;

export default Money;
